import { CARD_STATE } from '../../../utils/constants/general';

export const getPassPlacementCardState = (isLoading, hasError, data) => {
  if (isLoading) {
    return {
      state: CARD_STATE.LOADING,
      title: 'Loading',
      description: `Please wait loading data.`,
    };
  }

  if (data && data?.passEvents?.edges.length === 0 && !hasError) {
    return {
      state: CARD_STATE.EMPTY,
      title: 'No data available',
      description: `No data available for this player.`,
    };
  }
  if (!isLoading && hasError) {
    return {
      state: CARD_STATE.ERROR,
      title: 'Error',
      description: `An error occurred while loading player data.`,
    };
  }
  return {
    state: null,
    title: '',
    description: ``,
  };
};
